import pkg from '../../package.json';

export const environment = {
  production: false,
  appVersion: pkg.version + '-staging',
  apiUrl: 'https://safestock-api-staging.azurewebsites.net/api/',
};
